import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleCard from "@/components/feature/ArticleCard";
import BackToTop from "@/components/base/BackToTop";
import Breadcrumb from "@/components/base/Breadcrumb";
import SEOMeta from "@/components/base/SEOMeta";
import { categories, articles } from "@/mocks/articles";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeCategory, setActiveCategory] = useState(slug || "all");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  useEffect(() => {
    if (slug) setActiveCategory(slug);
  }, [slug]);

  const currentCategory = categories.find((c) => c.slug === activeCategory);
  const filteredArticles = activeCategory === "all"
    ? articles
    : articles.filter((a) => a.category === activeCategory);

  const breadcrumbItems = [
    { label: "首页", href: "/" },
    { label: currentCategory ? currentCategory.name : "全部分类" },
  ];

  const pageTitle = currentCategory ? `${currentCategory.name}视频` : "全部分类视频";

  return (
    <>
      <SEOMeta
        title={currentCategory ? `${currentCategory.name} - CSGO视频` : "视频分类"}
        description={currentCategory ? `${currentCategory.description}。浏览B站暴躁少女CSGO视频中的所有${currentCategory.name}内容。` : "浏览B站暴躁少女CSGO视频的所有分类内容，包括暴躁时刻、精彩操作、搞笑集锦、新手教学和资讯速递。"}
        keywords={`B站暴躁少女CSGO视频,${currentCategory?.name || "CSGO"},暴躁少女,视频${currentCategory ? `,${currentCategory.name}` : ""}`}
        canonicalPath={slug ? `/category/${slug}` : "/category/all"}
      />

      <Navbar />

      <main className="pt-20">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb items={breadcrumbItems} />

          {/* Category Header */}
          <section className="py-8 md:py-12">
            <h1 className="text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
              {currentCategory ? currentCategory.name : "视频分类"}
            </h1>
            {currentCategory && (
              <p className="text-foreground-600 max-w-2xl">{currentCategory.description}</p>
            )}
          </section>

          {/* Category Tabs */}
          <div className="flex items-center gap-2 pb-8 overflow-x-auto flex-wrap">
            <Link
              to="/category/all"
              onClick={() => setActiveCategory("all")}
              className={`px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                activeCategory === "all"
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-background-200"
              }`}
            >
              全部
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                onClick={() => setActiveCategory(cat.slug)}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  activeCategory === cat.slug
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-700 hover:bg-background-200"
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          {/* Articles Grid */}
          <section className="pb-14 md:pb-20">
            {filteredArticles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {filteredArticles.map((article) => (
                  <ArticleCard
                    key={article.id}
                    slug={article.slug}
                    title={article.title}
                    excerpt={article.excerpt}
                    image={article.image}
                    date={article.date}
                    categoryName={article.categoryName}
                    categorySlug={article.category}
                    tags={article.tags}
                    views={article.views}
                    likes={article.likes}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200 text-foreground-400">
                  <i className="ri-inbox-line text-2xl"></i>
                </div>
                <p className="text-foreground-500">该分类下暂无内容</p>
              </div>
            )}
          </section>
        </div>
      </main>

      <Footer />
      <BackToTop />
    </>
  );
}